'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('../../asset/css/demo-ui.css');

require('../../asset/icon-font/fontello.min.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Layout = function Layout(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'app background' },
    children
  );
};

Layout.propTypes = {
  children: _propTypes2.default.node
};

exports.default = Layout;


//////////////////
// WEBPACK FOOTER
// ./~/demo-ui/lib/theme/Layout.js
// module id = 516
// module chunks = 0